/**
 * ServiceMetadataCard — the "Metadata" card (created/updated/deleted audit
 * info) on the Service Detail page. Purely presentational. Extracted from
 * `routes/services/$serviceId.tsx` (issue #1411).
 */
import type { Service } from '../../graphql/types';

const CardElement = 'forge-card' as React.ElementType;
const DividerElement = 'forge-divider' as React.ElementType;

function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export interface ServiceMetadataCardProps {
  service: Service;
}

export function ServiceMetadataCard({ service }: ServiceMetadataCardProps): JSX.Element {
  return (
    <CardElement className="service-card">
      <div className="card-header">
        <h2 className="forge-typography--headline6">Metadata</h2>
      </div>
      <DividerElement />
      <div className="card-content">
        <div className="detail-row">
          <span className="detail-label">Created</span>
          <span className="detail-value">
            {formatDate(service._createdAt)}
            <span className="detail-secondary"> by {service._createdBy}</span>
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Last Updated</span>
          <span className="detail-value">
            {formatDate(service._updatedAt)}
            <span className="detail-secondary"> by {service._updatedBy}</span>
          </span>
        </div>
        {service._deletedAt && (
          <div className="detail-row">
            <span className="detail-label">Deleted</span>
            <span className="detail-value detail-value-error">
              {formatDate(service._deletedAt)}
            </span>
          </div>
        )}
      </div>
    </CardElement>
  );
}
